<template>
  <hr class="sb-dropdown-separator" />
</template>
